module.exports = __webpack_public_path__ + "static/img/hover12.b2cdac22.png";